var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAccessibility = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "accessibility_svg__a",
  width: 40,
  height: 40,
  x: 0,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "alpha"
  }
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M0 0h40v40H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#accessibility_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M20.002 9.611a3.028 3.028 0 0 1-2.217-.921 3.017 3.017 0 0 1-.924-2.216c0-.862.307-1.601.921-2.217a3.017 3.017 0 0 1 2.216-.924c.862 0 1.601.307 2.217.922.616.614.924 1.352.924 2.215 0 .863-.307 1.602-.921 2.218a3.017 3.017 0 0 1-2.216.923Zm-4.64 27.056V14.639a76.152 76.152 0 0 1-5.348-.597A52.265 52.265 0 0 1 5 13.056l.694-2.778c2.297.565 4.63.97 7 1.215 2.37.245 4.806.368 7.306.368s4.935-.123 7.305-.368 4.704-.65 7-1.215L35 13.056a52.268 52.268 0 0 1-5.014.986c-1.75.259-3.532.46-5.347.6v22.025H21.86V26.11H18.14v10.556H15.36Z"
}))));
export default SvgAccessibility;